// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_rm-0";
export var checkoutRateBadgeLink = "_rm-1";